import 'Styles/polls.scss';
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import rawToReact from 'Utils/bbcode/RawToReact';
import { displayNotification } from 'Actions/UiActions';
import { doPollVote } from 'Actions/ThreadviewActions';
import CheckboxComponent from 'Components/common/CheckboxComponent';

import threadViewSelector from 'Selectors/threadViewSelector';

class PollDataComponent extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			radioVote: '',
			checkVote: []
		};
	}

	buildPollOption = ( pollChoice, multiVote ) => {
		// Parse bbCode allowing HTML
		const pollOptionText = rawToReact( pollChoice.text, this.props, true );

		return  (
			<li key={pollChoice.id}>
				<CheckboxComponent
					name={ `votes_${ pollChoice.poll }` }
					id={ `pollOpt_${ pollChoice.id }` }
					value={ pollChoice.id }
					checked={ this.state.checkVote.indexOf( pollChoice.id ) !== -1 }
					multiple={ multiVote }
					className={ 'pollVote' }
					label={ pollOptionText }
					onChange={ ( e ) => this.saveCheckedField( e ) }
				/>
			</li>
		);
	};

	saveCheckedField( event ) {
		let fieldValue = event.target.checked ? event.target.value : false;

		if( event.target.type === 'checkbox' ) { // multiple
			let tempCheckVote = this.state.checkVote,
				currentPos = this.state.checkVote.indexOf( event.target.value );

			if( !fieldValue && currentPos >= 0 ) {// deselecting exiting value
				tempCheckVote.splice( currentPos, 1 );
			} else if( fieldValue && currentPos < 0 ) { // selecting non existing value
				tempCheckVote.push( fieldValue );
			}
			this.setState( { checkVote: tempCheckVote } );

		} else {
			this.setState( { radioVote: fieldValue } );
		}
	}

	buildPollResult = ( pollVote, pollOption, noShowResultsText, voteTotal ) => {
		let votes = noShowResultsText ? '-' : parseInt(pollVote.votes),
			votePercent = ( voteTotal > 0 ? Math.round((parseInt(pollVote.votes)/voteTotal)*100) : 0 );

		// Parse bbCode allowing HTML
		let pollOptionText = rawToReact( pollOption.text, this.props, true );

		return (
			<li key={ pollOption.id }>
				<p className="result">
					{ pollOptionText }
				</p>
				<div className="result-bar">
					<p data-percent= { votePercent } style={{width: votePercent + '%' }}><span>{ noShowResultsText ? '' : votePercent }&#37;</span></p>
					<span className="votes-result">{ votes } votes</span>
				</div>
			</li>
		);
	};

	countVotes = (pollVote) => {
		return parseInt(pollVote.votes);
	};

	onPollOptionsClick = () => {
		let choices = document.getElementsByClassName("choices-poll");
		for( let i = 0; i<choices.length; i++ ) {
			choices[i].classList.remove('hide-poll');
		}
		let results = document.getElementsByClassName("results-poll");
		for( let i = 0; i<results.length; i++ ) {
			results[i].classList.add('hide-poll');
		}
	};

	onSubmitVoteClick = () => {
		let voteValue = '',
			pollID = this.props.threadview.result.polls[0];
		if( this.state.radioVote !== '' ) {
			voteValue = /[^-]+$/.exec(this.state.radioVote);
		} else if( this.state.checkVote !== '') {
			let i, len;
			for (i = 0, len = this.state.checkVote.length; i < len; i++) {
				if( voteValue === '' ){
					voteValue = /[^-]+$/.exec(this.state.checkVote[i]);
				} else {
					voteValue += ';'+/[^-]+$/.exec(this.state.checkVote[i]);
				}
			}
		} else {
			displayNotification( 'error', 'Please select a poll option and submit again.', { force: true, timeout: 2000 } );
			return false;
		}

		this.props.dispatch( doPollVote({
			pollID:  pollID,
			topic: this.props.threadview.threadid,
			votes: voteValue
		}) );
	};

	onViewResultsClick = () => {
		let results = document.getElementsByClassName("results-poll");
		for( let i = 0; i<results.length; i++ ) {
			results[i].classList.remove('hide-poll');
		}
		let choices = document.getElementsByClassName("choices-poll");
		for( let i = 0; i<choices.length; i++ ) {
			choices[i].classList.add('hide-poll');
		}
	};

	render() {
		const { entities: { pollOptions, polls, pollVotes }, result } = this.props.threadview;
		if (result.polls.length === 0) {
			return null;
		}

		const pollID = result.polls[0];
		let showPoll = ( !polls[pollID].closed && polls[pollID].uservote === '' ),
			closedPoll = ( polls[pollID].closed ) ? <li className='result-poll poll-option'><p>Poll is Closed</p></li> : null,
			votedPoll = ( polls[pollID].uservote !== '' && !polls[pollID].closed ) ? <li className='result-poll poll-option'><p>You Voted</p></li> : null,
			gobackPoll = ( !polls[pollID].closed && polls[pollID].uservote === '' ) ? <li className='result-poll poll-option'><p className='viewOptions' data-type='typePoll' onClick={this.onPollOptionsClick} >Return to Poll Options</p></li> : null,
			reviewPoll = ( polls[pollID].showresults ) ? <p className='viewResults' data-type='typePoll' onClick={this.onViewResultsClick} >View Poll Results</p> : null,
			hideResults = ( showPoll ) ? 'hide-poll' : '',
			hideChoices = ( !showPoll ) ? 'hide-poll' : '';

		let question = '', noShowResultsText = null;
		if( polls ){
			question = polls[result.polls[0]].question;
			if( polls[result.polls[0]].noshowresultstext !== '' ){
				noShowResultsText = polls[result.polls[0]].noshowresultstext;
			}
		}

		const multiVote = polls[pollID].multiple === '1';
		const voteCount = result.pollVotes ? result.pollVotes.map( ( k, i ) => this.countVotes( pollVotes[ k ] ) ) : <span />;
		const voteTotal = voteCount.reduce((a, b) => a + b, 0);
		const pollChoices = result.pollOptions ? result.pollOptions.map( ( k, i ) => this.buildPollOption( pollOptions[ k ], multiVote ) ) : <span />;
		const pollResults = result.pollVotes ? result.pollVotes.map( ( k, i ) => this.buildPollResult( pollVotes[k], pollOptions[k], noShowResultsText, voteTotal ) ) : <span />;

		return (
			<div className='pollContainer'>
				<ul className='cards'>
					<li className='title'>
						<h6>POLL: { question }</h6>
						<span className="note">{ noShowResultsText }</span>
					</li>
					<li className={'topic-card sticky taking-poll choices-poll ' + (hideChoices)}><ul>{pollChoices}</ul></li>
					<li className={'topic-card sticky result-poll results-poll ' + (hideResults)}><ul>{pollResults}</ul></li>
				</ul>
				<ul className={'cards choices-poll ' + (hideChoices)}>
					<li className='card-actions taking-poll poll-option'>
						<input type='button' value='Submit your vote' className='poll-submit' id='submit_poll_vote' data-type='typePoll' onClick={this.onSubmitVoteClick} />
						{reviewPoll}
					</li>
				</ul>
		 		<ul className={'cards results-poll ' + (hideResults)}>
					{closedPoll}
					{votedPoll}
					{gobackPoll}
				</ul>
			</div>
		);
	}
}


PollDataComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	threadview: PropTypes.object.isRequired,
};


export default connect(threadViewSelector)(PollDataComponent);


// WEBPACK FOOTER //
// ./src/components/posts/PollDataComponent.js